module.exports = __webpack_public_path__ + "img/add_desktop_step1.5ff12fd3.jpeg";